import React, { useState, useEffect } from "react";
import { Table, message, Space, Modal, Pagination, Button } from "antd";
import { ReloadOutlined, DeleteOutlined } from "@ant-design/icons";
import { get, put, remove } from "../../../utils/apiUtils";
import AppModal from "../../modals/AppModal";

interface DeletedProjectsModalProps {
  visible: boolean;
  onCancel: () => void;
  workspaceId: any;
  restore: any;
}

const DeletedProject: React.FC<DeletedProjectsModalProps> = ({
  visible,
  onCancel,
  workspaceId,
  restore,
}) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectionType, setSelectionType] = useState<"checkbox">("checkbox");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalProjects, setTotalProjects] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState<any | null>(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      fetchDeletedProjects();
    }
  }, [visible, currentPage, pageSize]);

  // const columns = [
  //   {
  //     title: "Project Name",
  //     dataIndex: "name",
  //     key: "name",
  //   },
  //   {
  //     title: "Time remaining",
  //     dataIndex: "time_remaining",
  //     key: "time_remaining",
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (_: any, record: any) => (
  //       <Space size="middle">
  //         <ReloadOutlined onClick={() => restoreProject(record.id)} />
  //         <DeleteOutlined onClick={() => deleteProjectPermanently(record.id)} />
  //       </Space>
  //     ),
  //   },
  // ];

  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: "Time remaining",
      dataIndex: "time_remaining",
      key: "time_remaining",
      sorter: (a: any, b: any) => {
        const aVal = parseInt(a.time_remaining);
        const bVal = parseInt(b.time_remaining);
        return aVal - bVal;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <ReloadOutlined
            onClick={() => restoreProject(record.id)}
            style={{ color: "#A072EB" }}
          />
          {/* <DeleteOutlined
            style={{ color: "#A072EB" }}
            onClick={() => deleteProjectPermanently(record.id)}
          /> */}
          <DeleteOutlined
            style={{ color: "#A072EB" }}
            onClick={() => {
              setProjectToDelete(record);
              setConfirmOpen(true);
            }}
          />
        </Space>
      ),
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.name === "Disabled Project", // Column configuration not to be checked
      name: record.name,
    }),
  };
  const fetchDeletedProjects = async () => {
    setLoading(true);
    try {
      let response = await get<any>("projects/deleted");
      if (response.type === "success") {
        setProjects(response.data);
      }
    } catch {
      // silently ignore — user may not have access to deleted projects
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeletedProjects();
  }, []);

  const restoreProject = async (id: any) => {
    try {
      setLoading(true);

      let response = await put<any>(`projects/${id}/restore`, {});
      if (response.type === "success") {
        message.success(response?.data.message);
        await fetchDeletedProjects();

        if (restore) {
          restore();
        }
      }
    } catch (error: any) {
      message.error("Failed to restore project: " + error.message);
    } finally {
      setLoading(false);
    }
  };
  const deleteProjectPermanently = async (id: any) => {
    try {
      setDeleteLoading(true);

      const response = await remove(`projects/${id}/permanent`);

      if (response?.type === "success") {
        message.success("Project deleted successfully");
        await fetchDeletedProjects();
        setConfirmOpen(false);
        setProjectToDelete(null);
      }
    } catch (error: any) {
      message.error("Failed to delete project: " + error.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleTableChange = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <>
      <Modal
        title="Deleted Projects"
        open={visible}
        onCancel={onCancel}
        footer={[
          <Button
            key="back"
            onClick={onCancel}
            className="go-back-button-for-deleted-project"
            style={{
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: 500,
              backgroundColor: "#A072EB",
              border: "1px solid #A072EB",
              color: "white",
              height: "44px",
              borderRadius: "8px",
            }}
          >
            Go back
          </Button>,
        ]}
        className="archived-project-modal"
        style={{ minWidth: "1046px" }}
      >
        {/* <Table
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        columns={columns}
        dataSource={projects}
        rowKey="id"
      /> */}
        <Table
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
          columns={columns}
          dataSource={projects}
          rowKey="id"
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            onChange: handleTableChange,
          }}
        />
      </Modal>

      {/* {loading ? (
        <p>Loading...</p>
      ) : (
        <Table
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
          columns={columns}
          dataSource={projects}
          rowKey="id"
          scroll={{ x: 700 }}
        />
      )}{" "} */}
      <AppModal
        open={confirmOpen}
        onCancel={() => {
          if (deleteLoading) return;
          setConfirmOpen(false);
          setProjectToDelete(null);
        }}
        onConfirm={() => {
          if (!projectToDelete) return;
          return deleteProjectPermanently(projectToDelete.id);
        }}
        title="Delete project"
        description={`Deleting this project will automatically move it to Archived Projects. Are you sure you want to continue?`}
        confirmText="Delete"
        cancelText="Cancel"
        danger
        loading={deleteLoading}
        footerAlign="right"
        className="delete-project-permanently-modal"
      />
    </>
  );
};

export default DeletedProject;
